(function () {
    'use strict';

    var form = document.getElementById('schedule-form');
    if (!form) return;

    // submit時にフォーム内容をJSON化してhidden inputに格納（max_input_vars対策）
    form.addEventListener('submit', function () {
        var rows = document.querySelectorAll('#schedule-tbody tr[data-date-key]');
        var schedules = {};
        rows.forEach(function (row) {
            var dateKey = row.getAttribute('data-date-key');
            schedules[dateKey] = {};
            var inputs = row.querySelectorAll('input[name], textarea[name], select[name]');
            inputs.forEach(function (input) {
                var match = input.name.match(/\[([^\]]+)\]$/);
                if (match) {
                    schedules[dateKey][match[1]] = input.value;
                }
            });
        });
        document.getElementById('schedules-json-input').value = JSON.stringify(schedules);

        var allScheduleInputs = document.querySelectorAll('[name^="schedules["]');
        allScheduleInputs.forEach(function (el) {
            if (el.id !== 'schedules-json-input') {
                el.disabled = true;
            }
        });
    });

    // 雛形適用
    var applyBtn = document.getElementById('apply-template-btn');
    if (!applyBtn) return;

    applyBtn.addEventListener('click', function () {
        var select = document.getElementById('template-select');
        var templateId = select.value;
        if (!templateId) {
            alert('雛形を選択してください。');
            return;
        }
        if (!confirm('雛形を適用すると現在の入力内容(対面指導内容、備考)が上書きされます。よろしいですか？')) {
            return;
        }

        var beginDate = new Date(form.dataset.beginDate);
        var url = form.dataset.templateItemsUrl.replace(':id', templateId);

        fetch(url)
            .then(function (res) { return res.json(); })
            .then(function (data) {
                var rows = document.querySelectorAll('#schedule-tbody tr[data-date-key]');
                var fields = ['online_lesson_content', 'remarks'];

                rows.forEach(function (row) {
                    var dateKey = row.getAttribute('data-date-key');
                    var rowDate = new Date(dateKey);
                    var diffDays = Math.round((rowDate - beginDate) / (1000 * 60 * 60 * 24)) + 1;
                    var item = data.items[String(diffDays)];

                    fields.forEach(function (field) {
                        var el = row.querySelector('[name="schedules[' + dateKey + '][' + field + ']"]');
                        if (el) {
                            el.value = item ? (item[field] || '') : '';
                        }
                    });
                });

                alert('雛形を適用しました。');
            })
            .catch(function () {
                alert('雛形の取得に失敗しました。');
            });
    });
})();
